module.exports = __webpack_public_path__ + "img/6.1aa598be.png";